import { render, staticRenderFns } from "./HomeCommonSearch.vue?vue&type=template&id=118ffb4c&scoped=true&"
import script from "./HomeCommonSearch.vue?vue&type=script&lang=js&"
export * from "./HomeCommonSearch.vue?vue&type=script&lang=js&"
import style0 from "./HomeCommonSearch.vue?vue&type=style&index=0&id=118ffb4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118ffb4c",
  null
  
)

export default component.exports